import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiMapMarker } from "@mdi/js";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { zoomToFeatureByGeojson } from "../../Components/Map/Layers/TempLayer";
import { _serverUrl2 } from "../../config";
import "./Adv.css";

const MySwal = withReactContent(Swal);

export default function AdvTable({ columns, rows, routePath }) {
  const [showRows, setShowRows] = useState([]);
  const [hasGeojson, setHasGeojson] = useState(false);
  const [hasRoute, setHasRoute] = useState(false);

  useEffect(() => {
    setShowRows(rows);
    if (rows.length > 0) {
      setHasGeojson(rows[0].some((d) => d.type === "geom"));
      setHasRoute(rows[0].some((d) => d.type === "id"));
    }
  }, [rows]);

  const getRowCells = (metaRow) => {
    const filteredMetaRow = metaRow.filter((d) => d.type !== "id" && d.type !== "geom");
    return columns.map((_, i) => (
      <td key={i} style={{ padding: "3px", fontSize: "11px" }}>
        {filteredMetaRow[i].label}
      </td>
    ));
  };

  const handleSort = (columnIndex) => {
    const sortElement = document.getElementById(`sort_${columnIndex}`);
    const currentColor = sortElement.style.color;

    columns.forEach((_, i) => {
      if (i !== columnIndex) document.getElementById(`sort_${i}`).style.color = "lightgray";
    });

    let sortedArray;
    if (currentColor === "lightgray") {
      sortElement.style.color = "gray";
      sortedArray = [...showRows].sort((a, b) => a[columnIndex].value.localeCompare(b[columnIndex].value));
    } else if (currentColor === "gray") {
      sortElement.style.color = "black";
      sortedArray = [...showRows].sort((a, b) => b[columnIndex].value.localeCompare(a[columnIndex].value));
    } else {
      sortElement.style.color = "lightgray";
      sortedArray = rows;
    }
    setShowRows(sortedArray);
  };

  const handleExcelExport = async () => {
    const selectedColumns = columns.map((d, i) => ({ id: i, val: true, head: d }));

    const result = await MySwal.fire({
      title: "Excel Oluştur",
      html: (
        <div>
          <table className="table table-sm table-bordered table-hover table-striped">
            <tbody>
              {columns.map((d, i) => (
                <tr key={i}>
                  <td>{d}</td>
                  <td>
                    <input type="checkbox" onChange={(e) => (selectedColumns[i].val = e.target.checked)} defaultChecked={true} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ),
      confirmButtonText: "Excel Oluştur",
      cancelButtonText: "Vazgeç",
      showCancelButton: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios({
          url: `${_serverUrl2}/main/createExcelFromTable`,
          method: "POST",
          data: { data: showRows, filteredData: selectedColumns, name: "noktasalYazilim" },
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "EBS-TabloEkrani.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Excel oluşturma hatası:", error);
      }
    }
  };

  return (
    <div className="tableFixHead">
      <table className="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <td colSpan={columns.length + (hasGeojson ? 1 : 0) + (hasRoute ? 1 : 0)}>
              <div className="d-flex justify-content-between" style={{ height: "23px" }}>
                <button onClick={handleExcelExport} className="greenBtn" style={{ width: "50px", fontSize: "10px", padding: "4px" }}>
                  Excel
                </button>
                <div>
                  <i style={{ fontSize: "9px" }}>
                    Toplam <b>{showRows.length}</b> Kayıt Listeleniyor
                  </i>
                </div>
              </div>
            </td>
          </tr>
          <tr className="header shadow" style={{ backgroundColor: "whitesmoke", position: "sticky", top: "0px", fontSize: "10px" }}>
            {hasGeojson && <td style={{ maxWidth: "18px", backgroundColor: "whitesmoke" }}></td>}
            {columns.map((d, i) => (
              <td key={i} style={{ position: "relative", padding: "2px", paddingRight: "4px", paddingBottom: "4px", verticalAlign: "middle" }}>
                {d}
                <div style={{ position: "absolute", right: "1px", bottom: "1px" }}>
                  <i
                    id={`sort_${i}`}
                    style={{ position: "sticky", right: "1px", color: "lightgray" }}
                    onClick={() => handleSort(i)}
                    className="advIco fas fa-sort fa-lg"
                  ></i>
                </div>
              </td>
            ))}
            {hasRoute && <td></td>}
          </tr>
        </thead>
        <tbody>
          {showRows.map((row, rowIndex) => (
            <tr key={rowIndex} style={{ fontSize: "12px" }}>
              {hasGeojson && (
                <td onClick={() => zoomToFeatureByGeojson(row.find((z) => z.type === "geom").value)} style={{ verticalAlign: "middle", padding: "4px" }}>
                  <div style={{ fontSize: "12px", fontWeight: "light" }} className="layersBtn pointer">
                    <Icon path={mdiMapMarker} size={1.23} style={{ color: "#344e75", cursor: "pointer" }} />
                  </div>
                </td>
              )}
              {getRowCells(row)}
              {hasRoute && (
                <td style={{ backgroundColor: "whitesmoke", verticalAlign: "middle", padding: "4px" }}>
                  <Link
                    to={`${routePath}${row.find((z) => z.type === "id").value}`}
                    className="layersBtn pointer"
                    style={{ width: "26px", height: "26px", fontSize: "12px", fontWeight: "light", padding: "7px", backgroundColor: "#f79224" }}
                  >
                    <i style={{ color: "black" }} className="fas fa-folder-open fa-lg"></i>
                  </Link>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
